<template>
  <div class="jury-selection" style="heigh: 100% !important;">
    <v-container>
      <!-- Loader while data is loading -->
      <v-row v-if="loading" justify="center" align="center" class="fill-height">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-row>

      <!-- Jury Carousel -->
      <v-row v-else justify="center" align="center" class="fill-height">

        <!-- Choose Your Profile Text -->
        <v-row justify="center" class="mb-4">
          <v-col cols="auto">
            <h2 class="text-center">Choisissez votre profil</h2>
          </v-col>
        </v-row>
        <v-carousel hide-delimiters height="300" v-model="currentJuryIndex" @change="setCurrentJury(currentJuryIndex)">
          <v-carousel-item
            v-for="(jury) in juries"
            :key="jury.id"
            :style="{ margin: '0 5px' }"
          >
            <v-card class="pa-4" :style="{ width: '300px', margin: 'auto', backgroundColor: colors.primary }">
              <v-avatar class="mx-auto mb-3" size="200">
                <v-img :src="getJuryImageUrl(jury.image)" alt="Jury Image" aspect-ratio="1"></v-img>
              </v-avatar>
              <h3 class="text-center" style="color:white;">{{ jury.name }}</h3>
            </v-card>
          </v-carousel-item>
        </v-carousel>

        <!-- Single Button for Selection -->
        <div style="flex-direction: column;">
          <v-btn
            class="mx-auto mt-3"
            :style="{ backgroundColor: colors.primary, color: colors.secondary }"
            @click="selectJury"
          >
            Sélectionner
          </v-btn>
          <v-btn
            class="mx-auto mt-3"
            color="primary"
            @click="goToResults"
          >
            Accéder aux résultats
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../api'; // Import the API file
import colors from '../styles/colors'; // Import the colors file
import { mapActions } from 'vuex';

export default {
  name: 'JurySelection',
  data() {
    return {
      juries: [],
      currentJuryIndex: 0, // Track the current jury index
      loading: false, // Loading state
      colors, // Add colors to the data object
    };
  },
  created() {
    this.fetchJuries();
  },
  methods: {
    ...mapActions(['updateJury']),
    async fetchJuries() {
      this.loading = true; // Set loading to true when starting the API call
      try {
        const response = await axios.get(api.getJuries);
        this.juries = response.data;
      } catch (error) {
        console.error('Error fetching juries:', error);
      } finally {
        this.loading = false; // Set loading to false once the data is fetched
      }
    },
    getJuryImageUrl(filename) {
      return api.getJuryImageUrl(filename); // Generate full image path
    },
    setCurrentJury(index) {
      this.currentJuryIndex = index; // Update the current jury index
    },
    goToResults() {
      this.$router.push('/results');
    },
    selectJury() {
      const selectedJury = this.juries[this.currentJuryIndex];
      if (selectedJury) {
        this.updateJury(selectedJury); // Save selected jury to Vuex
        //this.$router.push('/evaluation'); // Redirect to Evaluation screen
        this.$nextTick(() => {
          this.$router.push('/evaluation'); // Redirect to Evaluation screen
        });
      }
    },
  },
};
</script>

<style scoped>
.jury-selection {
  text-align: center;
  min-height: 100vh; /* Ensure the section takes up full height */
}

.v-card {
  margin: auto;
  width: 400px;
}

.v-avatar {
  overflow: hidden;
}

.v-btn {
  display: block;
  margin: 20px auto;
}

.fill-height {
  min-height: 100vh; /* Make sure the container takes up full height */
}

.v-carousel {
  max-width: 100%;
  height: 100%;
}

.v-carousel-item {
  /* Adjust the margins of carousel items to make them closer */
  margin: 0 10px;
}
</style>
